import React from "react"
import Layout from "../components/layout"

export default () => (
  <Layout>
    <p>(Teh contact page)</p>
  </Layout>
)
